<template>
  <div>
    <div class="container-fluid content-banner">
      <div class="row">
        <div
          class="
            col
            main-header
            bg-warning
            text-dark
            font-weight-bold
            d-flex
            flex-column
            justify-content-center
            align-items-center
          "
          style="height: 370px"
        >
          <!-- <h1>I/O</h1> -->
          <div class="row">
            <div id="logo" class="col-6 mx-4 my-2"></div>
            <div id="logo-slash"></div>
            <div id="logo2" class="col-6"></div>
          </div>
          <h2 id="tag2">Experience IO</h2>
          <h2 id="tag3">With your local communties</h2>
          <button class="bg-light register-btn p-2 mt-3 outline-none border-0">
            Register Now
          </button>
        </div>
      </div>
      <div class="row  d-lg-block  design-banner-square" >

      </div>
        <div class="row  d-lg-block  design-banner-circle" >

      </div>
    </div>

    <!-- ______________WHY IO EXTENDED___________START -->

    <div class="container">
      <div class="row my-1 m-auto">
        <div class="col my-3 box">
          <h1>Why <span>IO Extended ?</span></h1>
        </div>
      </div>
      <div class="row my-1 d-flex justify-content-around">
        <div class="col-md-5 m-2 p-3 community-div">
          <h2 class="mb-3 mt-2">Because Community matters</h2>
          <div class="row">
            <div class="col-lg-10">
              <p>
                Amet sit sadipscing ea labore ea duo stet, magna diam labore,
                lorem aliquyam accusam vero no duo invidunt dolor. Sed sanctus
                erat diam lorem est consetetur et gubergren, no sed elitr lorem
                ipsum. Sadipscing lorem nonumy vero sit kasd tempor sanctus sit
                ipsum, et sit no consetetur no erat stet, diam tempor ut sed
                magna takimata
              </p>
            </div>
          </div>
        </div>
        <div class="col-md-5 m-2 p-2 growth-div">
          <h2 class="mb-3 mt-2">Because Community matters</h2>
          <div class="row">
            <div class="col-lg-10">
              <p>
                Amet sit sadipscing ea labore ea duo stet, magna diam labore,
                lorem aliquyam accusam vero no duo invidunt dolor. Sed sanctus
                erat diam lorem est consetetur et gubergren, no sed elitr lorem
                ipsum. Sadipscing lorem nonumy vero sit kasd tempor sanctus sit
                ipsum, et sit no consetetur no erat stet, diam tempor ut sed
                magna takimata
              </p>
            </div>
          </div>
        </div>
      </div>

      <div class="row my-2 d-flex justify-content-around">
        <div class="col-md-8 m-2 p-3 you-matter-div">
          <h2 class="mt-2">Because YOU matter</h2>
          <p>
               Amet sit sadipscing ea labore ea duo stet, magna diam labore,
                lorem aliquyam accusam vero no duo invidunt dolor. Sed sanctus
                erat diam lorem est consetetur et gubergren, no sed elitr lorem
                ipsum. Sadipscing lorem nonumy vero sit kasd tempor sanctus sit
                ipsum, et sit no consetetur no erat stet, diam tempor ut sed
                magna takimata
          </p>
        </div>
        <div class="col-md-2 m-1 p-3 calender-div text-center">
          <img src="../assets/calendar.png" alt="" />
          <h2 class="mt-3">16 July</h2>
          <h3>Friday</h3>
        </div>
      </div>
    </div>

    <!-- ______________WHY IO EXTENDED___________END -->

    <!-- ______________CELEBRATION OF TECH___________START -->

    <div class="container  mt-5">
      <div class="row mt-5">
        <div class="col m-auto mb-4 box d-flex justify-content-center">
          <h1 class="heading">
            A Local <span id="IO">Celebration of Tech </span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col m-auto partners-img d-flex justify-content-center">
          <img src="../assets/partners.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>
    <!-- ______________CELEBRATION OF _________END -->
<!-- ______________EVENT AGENDA_______start -->
<div class="container mt-5">
      <div class="row mt-5">
        <div class="col box m-auto d-flex justify-content-center">
          <h1 class="heading mb-4">
            Event <span id="IO">Agenda </span>
          </h1>
        </div>
      </div>
      <div class="row ">
       <events></events>
      </div>
    </div>

    <!-- ________EVENT AGENDA END________ -->


    <!-- ______________SPEAKERS LINEUP___________START -->

    <div class="container mt-5">
      <div class="row mt-5">
        <div class="col m-auto box d-flex justify-content-center">
          <h1 class="mb-5">Speakers <span id="IO">Lineup </span></h1>
        </div>
      </div>
      <div class="row">
        <div class="col-md">
          <div class="row d-flex justify-content-center align-items-center">
            <div class="col-md-5 text-center">
              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>
            </div>
            <div class="col-md-5 text-center">
              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>

              <div class="row mb-3">
                <div class="col-lg-4 ceo">
                  <img
                    width="100"
                    height="100"
                    src="../assets/ceo.png"
                    alt=""
                  />
                </div>
                <div class="col-lg-7 d-flex flex-column justify-content-center">
                  <h4>Jane Cooper</h4>
                  <p>CEO at ABC Company</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ______________SPEAKERS LINEUP___________END -->

    <!-- ______________PARTNERS COMMUNITIES__________START -->

    <div class="container mt-5">
      <div class="row mt-5">
        <div class="col box m-auto d-flex justify-content-center">
          <h1 class="heading mb-4">
            Partner <span id="IO">Communities </span>
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col m-auto d-flex justify-content-center">
          <img src="../assets/partners1.png" alt="" class="img-fluid" />
        </div>
      </div>
    </div>

    <!-- ______________PARTNERS COMMUNITIES__________END -->
  </div>
</template>

<script>
import Events  from './Events.vue'
export default {
  components:{
    Events
  }
};
</script>
<style  scoped>
@import url("https://fonts.googleapis.com/css2?family=Open+Sans:wght@600&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Roboto&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Bebas+Neue&display=swap");
/* @import url('https://fonts.googleapis.com/css2?family=Coda+Caption:wght@800&display=swap'); */
@import url("https://fonts.googleapis.com/css2?family=Poppins&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@300;700&display=swap");

/* _________MAIN_HEADER_START___________ */
/* .main-header h1 { */
/* font-weight: bolder; */
/* font-family: "Bebas Neue", cursive;
  color: rgb(0, 0, 0);
  font-weight: bolder;
  font-size: 5rem; */
/* font-family: 'Ultra', serif; */
/* font-family: 'Coda Caption', sans-serif; */
/* font-family: "Poppins", sans-serif;
} */

#logo {
  width: 40px;
  height: 90px;
  background: black;
}
#logo-slash {
  width: 1px;
  height: 140px;
  background: black;
  transform: rotateY(84deg) rotateX(-20deg);
  transform-origin: left;
  margin-top: -10px;
}

#logo2 {
  width: 100px;
  height: 100px;
  background: black;
  border-radius: 50%;
}
.content-banner{
  position: relative;
  overflow: hidden;
}
.design-banner-square{
  width: 200px;
  height: 200px;
  /* background: black; */
  border: 2px solid black;
  

  position: absolute;
  bottom: -20px;
  left: -20px;
  
}
.design-banner-circle{
    width: 300px;
  height: 300px;
  /* background: black; */
  border: 2px solid black;
  
  border-radius: 50%;
  position: absolute;
  top: -40%;
  right: -10%;
}


@media screen and (max-width:750px) {
  .design-banner-square,.design-banner-circle{
    display: none;
  }
  .calender-div{
    max-width: 300px;
  }
}

.main-header #tag1 {
  color: rgb(0, 0, 0);
  letter-spacing: 2px;
  font-family: "Noto Sans JP", sans-serif;
}
.register-btn {
  border-radius: 10px;
}
.main-header #tag2 {
  color: black;
  word-spacing: 3px;
  font-family: "Poppins", sans-serif;
  font-weight: bolder;
  font-size: 2.5rem;
}
.main-header #tag3 {
  font-family: "Poppins", sans-serif;
}
/* _________MAIN_HEADER_END___________ */

/* __________MATTERS DIV START_________ */
.col {
  font-family: "Open Sans", sans-serif;
}
h1 span {
  font-weight: bolder;
}

.box h1 {
  font-family: "Poppins", sans-serif;
}
.community-div {
  background: #f88c84;
}
.community-div,
.growth-div,
.you-matter-div,
.calender-div {
  border-radius: 30px;
  /* box-shadow: 10px 14px 17px -8px rgba(0,0,0,0.66);
-webkit-box-shadow: 10px 14px 17px -8px rgba(0,0,0,0.66);
-moz-box-shadow: 10px 14px 17px -8px rgba(0,0,0,0.66); */
  font-family: "Poppins", sans-serif;
}

.community-div p,
.growth-div p {
  margin: 10px;
  font-weight: 600;
  font-family: "Roboto", sans-serif;
}
.growth-div {
  background: #88cc94;
}
.you-matter-div {
  background: #ffbc04;
}
.calender-div {
  background: #3b8fff;
  color: wheat;
}

/* ___CEO */
.ceo img {
  border-radius: 50%;
}

/* __________MATTERS DIV END */

/* ______CELEBRATION OF TECH START________ */


#IO {
  font-weight: 900;
}
/* .heading {
  font-weight: bolder;
  font-size: 2rem;
} */
/* ______CELEBRATION OF TECH END */

/* _____EVENT START____ */
.event_icons{
  margin-left: -80px;
}
/* _____EVENT END______ */

/* _____mix */

@media screen and (max-width:750px) {
  .calender-div{
    max-width: 160px;
    
   
  }
}
</style>